import { action, computed, observable, values, makeObservable } from 'mobx';

import { CallStatus, IGroupCallChanged } from '@gem/call/Model/callModel.types';

import { BackgroundCall } from './BackgroundCall/BackgroundCall';

export class BackgroundCalls {
  @observable data = observable.map<string, BackgroundCall>({}, { deep: false });

  constructor() {
    makeObservable(this);
  }

  @action reset(): void {
    this.data.clear();
  }

  @action
  add(call: IGroupCallChanged): void {
    const backgroundCall = new BackgroundCall({
      groupId: call.groupId,
      channelId: call.channelId,
      callProvider: call.callProvider,
    });

    this.data.set(call.channelId, backgroundCall);
  }

  @action
  replace(calls: IGroupCallChanged[]): void {
    this.data.clear();
    calls
      .filter(({ status }) => status === CallStatus.Started)
      .forEach((call) => {
        this.add(call);
      });
  }

  @action
  delete(channelId?: string, groupId?: string): void {
    let call = null;

    if (channelId) {
      call = this.data.get(channelId);
    }

    if (groupId && !call) {
      call = this.getCallByGroupId(groupId);
    }

    if (call) {
      this.data.delete(call.channelId);
    }
  }

  @computed
  get hasCall(): boolean {
    return !!this.data.size;
  }

  get calls(): readonly BackgroundCall[] {
    return values(this.data);
  }

  getCallByChannelId(channelId: string): BackgroundCall | null {
    return this.data.get(channelId) || null;
  }

  getCallByGroupId(groupId: string): BackgroundCall | null {
    return this.calls.find((call) => call.groupId === groupId) || null;
  }
}
